import React from "react";
import {Card, CardContent, CardDescription, CardHeader, CardTitle} from "../ui/Card";
import {Button} from "../ui/Button";
import {Form, FormControl, FormField, FormItem, FormLabel} from "../ui/Form";
import {Input} from "../ui/Input";
import {Link} from "react-router-dom";
import {z} from "zod";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import {Textarea} from "../ui/Textarea";

const formSchema = z.object({
    fullName: z.string().min(1, {
        message: "Full name is required",
    }),
    title: z.string().min(1, {
        message: "Title is required"
    }),
    subject: z.string().min(1, {
        message: "Subject is required"
    })
});


const Support = () => {
    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            email: "",
            password: ""
        },
    });

    const { isSubmitting, isValid } = form.formState;

    const submitTicket = (values) => {

    }

    return (
        <Card>
            <CardHeader className="border-b border-black border-dotted">
                <CardTitle className="text-black">Experiencing trouble or problems?</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="relative w-1/2 mx-auto pt-4">
                    <CardDescription className="uppercase font-bold">
                        Submit a ticket to our support team
                    </CardDescription>
                    <Form {...form}>
                        <form onSubmit={form.handleSubmit(submitTicket)} className="mt-8  space-y-8">
                            <FormField
                                control={form.control}
                                name="fullName"
                                render={({field}) => (
                                    <FormItem>
                                        <div>
                                            <FormLabel>Full Name</FormLabel>
                                            <FormControl>
                                                <Input placeholder="Enter full name" {...field} type='word' disabled={isSubmitting}
                                                       className="w-full font-rubik"
                                                />
                                            </FormControl>
                                        </div>
                                    </FormItem>
                                )}
                            />
                            <FormField
                                control={form.control}
                                name="title"
                                render={({field}) => (
                                    <FormItem>
                                        <div>
                                            <FormLabel>Title</FormLabel>
                                            <FormControl>
                                                <Input placeholder="Enter title" {...field} type='word' disabled={isSubmitting}
                                                       className="w-full font-rubik"
                                                />
                                            </FormControl>
                                        </div>
                                    </FormItem>
                                )}
                            />
                            <FormField
                                control={form.control}
                                name="subject"
                                render={({field}) => (
                                    <FormItem>
                                        <div>
                                            <FormLabel>Subject</FormLabel>
                                            <FormControl>
                                                <Textarea placeholder="Enter title" {...field} type='word' disabled={isSubmitting}
                                                       className="w-full font-rubik"
                                                />
                                            </FormControl>
                                        </div>
                                    </FormItem>
                                )}
                            />
                            <div className="pb-16">
                                <Button className="w-full uppercase" type="submit" disabled={!isValid || isSubmitting}>
                                    Submit a ticket
                                </Button>
                            </div>
                        </form>
                    </Form>
                </div>
            </CardContent>
        </Card>
    )
}

export default Support;